import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { highlightCodeInContent } from "~/components/TinyMCEDialogs/CodeHighLighter";
import { makeGetAllAttachmentsByParent } from "~/store/selectors/selector.attachments";
import { Description } from "../description/Description";
import { useFilePreviewContext, useFileTokenContext } from "../FilePreview";

export const DescriptionWrapper = ({ parentId, parentType, body, onDoubleClick, className }) => {
  const { openFilePreview } = useFilePreviewContext();
  const { preview_token, download_token, thumb_token } = useFileTokenContext();
  const descriptionBody = useMemo(() => {
    const processedBody = highlightCodeInContent(body);

    return processedBody
      .replace(/--THUMBNAIL-TOKEN--/g, thumb_token)
      .replace(/--PREVIEW-TOKEN--/g, preview_token)
      .replace(/--DOWNLOAD-TOKEN--/g, download_token);
  }, [body, thumb_token, preview_token, download_token]);

  const getAllAttachmentsByParent = useMemo(() => {
    return makeGetAllAttachmentsByParent({
      parentType,
      parentId,
    });
  }, [parentId, parentType]);
  const attachments = useSelector(getAllAttachmentsByParent);

  const handleOpenFilePreview = useCallback(
    (parentId) => openFilePreview(parentId, attachments),
    [attachments, openFilePreview]
  );

  return (
    <Description
      className={className}
      body={descriptionBody}
      onDoubleClick={onDoubleClick}
      onImageClick={handleOpenFilePreview}
    />
  );
};

DescriptionWrapper.propTypes = {
  parentId: PropTypes.number.isRequired,
  parentType: PropTypes.string.isRequired,
  body: PropTypes.string,
  onDoubleClick: PropTypes.func,
  className: PropTypes.string,
};

DescriptionWrapper.defaultProps = {
  onDoubleClick: () => null,
  body: "",
};
